// src/pages/logias/LogiasGLP.jsx
import { useState, useEffect } from 'react';

// Base de datos completa oficial de Logias de la Gran Logia del Perú
const logiasData = [
  { numero: 1, nombre: "Paz y Perfecta Unión", valle: "Lima", fundacion: "1817" },
  { numero: 2, nombre: "Orden y Libertad", valle: "Lima", fundacion: "1822" },
  { numero: 3, nombre: "Virtud y Unión", valle: "Lima", fundacion: "1823" },
  { numero: 4, nombre: "Parthenón", valle: "Lima", fundacion: "1824" },
  { numero: 5, nombre: "Honor y Progreso", valle: "Lima", fundacion: "1829" },
  { numero: 6, nombre: "Alianza y Firmeza", valle: "Lima", fundacion: "1871" },
  { numero: 7, nombre: "Kosmos", valle: "Lima", fundacion: "1873" },
  { numero: 8, nombre: "Arca de Noé", valle: "Lima", fundacion: "1873" },
  { numero: 9, nombre: "Excélsior", valle: "Lima", fundacion: "1923" },
  { numero: 10, nombre: "Ciencia y Trabajo", valle: "Lima", fundacion: "1928" },
  { numero: 11, nombre: "Constancia y Concordia", valle: "Callao", fundacion: "1862" },
  { numero: 12, nombre: "Cruz Austral", valle: "Lima", fundacion: "1853" },
  { numero: 13, nombre: "Cosmopolita", valle: "Trujillo", fundacion: "1883" },
  { numero: 14, nombre: "Concordia Universal", valle: "Callao", fundacion: "1849" },
  { numero: 15, nombre: "Aurora de Huancayo", valle: "Huancayo", fundacion: "1885" },
  { numero: 16, nombre: "Progreso Universal", valle: "Lima", fundacion: "1927" },
  { numero: 17, nombre: "Trabajo y Honradez", valle: "Lima", fundacion: "1936" },
  { numero: 18, nombre: "Tolerancia", valle: "Ica", fundacion: "1936" },
  { numero: 19, nombre: "Libertad y Justicia", valle: "Chepen", fundacion: "1936" },
  { numero: 20, nombre: "Nicolás de Piérola", valle: "Arequipa", fundacion: "1946" },
  { numero: 21, nombre: "Fénix, Paz y Trabajo", valle: "Arequipa", fundacion: "1892" },
  { numero: 22, nombre: "Luz del Norte", valle: "Tumbes", fundacion: "1946" },
  { numero: 23, nombre: "Oriental", valle: "Pucallpa", fundacion: "1939" },
  { numero: 24, nombre: "Porvenir de Huacho", valle: "Huacho", fundacion: "1886" },
  { numero: 25, nombre: "Unión Amazónica 5", valle: "Iquitos", fundacion: "1869" },
  { numero: 26, nombre: "Sol de los Incas", valle: "Cajamarca", fundacion: "1937" },
  { numero: 27, nombre: "Andina", valle: "Lima", fundacion: "1938" },
  { numero: 28, nombre: "Fraternidad y Progreso", valle: "Lima", fundacion: "1875" },
  { numero: 29, nombre: "Estrella del Norte", valle: "Chiclayo", fundacion: "1895" },
  { numero: 30, nombre: "Condorcunca", valle: "Ayacucho", fundacion: "1945" },
  { numero: 31, nombre: "Independencia", valle: "Callao", fundacion: "1948" },
  { numero: 32, nombre: "Luz y Libertad", valle: "Arequipa", fundacion: "1922" },
  { numero: 33, nombre: "Júpiter", valle: "Lima", fundacion: "1922" },
  { numero: 34, nombre: "Enrique Meiggs", valle: "Lima", fundacion: "1927" },
  { numero: 35, nombre: "Manco Cápac", valle: "Lima", fundacion: "1923" },
  { numero: 36, nombre: "José de San Martín", valle: "Lima", fundacion: "1924" },
  { numero: 37, nombre: "Luz y Verdad", valle: "Piura", fundacion: "1929" },
  { numero: 38, nombre: "Francisco de Paula Gonzáles Vigil", valle: "Tacna", fundacion: "1946" },
  { numero: 39, nombre: "Cuna de los Incas", valle: "Puno", fundacion: "1887" },
  { numero: 40, nombre: "Koricancha", valle: "Cusco", fundacion: "1942" },
  { numero: 41, nombre: "Pablo de Olavide", valle: "Nazca", fundacion: "1944" },
  { numero: 42, nombre: "Túpac Amaru", valle: "Lima", fundacion: "1944" },
  { numero: 43, nombre: "José Faustino Sánchez Carrión", valle: "Chincha", fundacion: "1945" },
  { numero: 44, nombre: "Estrella de Oriente", valle: "Cusco", fundacion: "1946" },
  { numero: 45, nombre: "Alfonso Ugarte", valle: "Cañete", fundacion: "1947" },
  { numero: 46, nombre: "Paz y Justicia", valle: "Lima", fundacion: "1949" },
  { numero: 47, nombre: "Orden y Reforma", valle: "Lima", fundacion: "1824" },
  { numero: 48, nombre: "Francisco Bolognesi", valle: "Lima", fundacion: "1963" },
  { numero: 49, nombre: "Estrella de Italia", valle: "Lima", fundacion: "1949" },
  { numero: 50, nombre: "Ampay", valle: "Abancay", fundacion: "1950" },
  { numero: 51, nombre: "Leoncio Prado", valle: "Huánuco", fundacion: "1950" },
  { numero: 52, nombre: "Sol de Oriente", valle: "Tingo María", fundacion: "1951" },
  { numero: 53, nombre: "Unión Fraternal del Chira Miguel Grau", valle: "Sullana", fundacion: "1952" },
  { numero: 54, nombre: "Heliópolis", valle: "Lima", fundacion: "1953" },
  { numero: 55, nombre: "José Gálvez Moreno", valle: "Tarma", fundacion: "1953" },
  { numero: 56, nombre: "Pariñas", valle: "Talara", fundacion: "1950" },
  { numero: 57, nombre: "Acacia", valle: "Negritos", fundacion: "1954" },
  { numero: 58, nombre: "Fraternidad Universal", valle: "Lima", fundacion: "1956" },
  { numero: 59, nombre: "Huascarán", valle: "Chimbote", fundacion: "1957" },
  { numero: 60, nombre: "Toquepala", valle: "Tacna", fundacion: "1960" },
  { numero: 61, nombre: "Ricardo Palma", valle: "Lima", fundacion: "1961" },
  { numero: 62, nombre: "Lautaro", valle: "Lima", fundacion: "1962" },
  { numero: 63, nombre: "Juan Santos Atahualpa", valle: "La Merced", fundacion: "1963" },
  { numero: 64, nombre: "Francisco Lewis Crosby", valle: "Lima", fundacion: "1964" },
  { numero: 65, nombre: "Hipólito Unánue", valle: "Lima", fundacion: "1964" },
  { numero: 66, nombre: "Acrópolis", valle: "Lima", fundacion: "1964" },
  { numero: 67, nombre: "Pascual Saco Oliveros", valle: "Lambayeque", fundacion: "1964" },
  { numero: 68, nombre: "San Juan", valle: "Marcona", fundacion: "1966" },
  { numero: 69, nombre: "Salud, Fuerza y Unión", valle: "Lima", fundacion: "1966" },
  { numero: 70, nombre: "Luz de Oriente", valle: "Iquitos", fundacion: "1965" },
  { numero: 71, nombre: "Mariscal Luis José Orbegoso", valle: "Trujillo", fundacion: "1965" },
  { numero: 72, nombre: "Lealtad y Superación", valle: "Lima", fundacion: "1966" },
  { numero: 73, nombre: "Sol del Perú", valle: "Lima", fundacion: "1966" },
  { numero: 74, nombre: "Eintracht 1869", valle: "Lima", fundacion: "1967" },
  { numero: 75, nombre: "José Gálvez Egúsquiza", valle: "Ilo", fundacion: "1967" },
  { numero: 76, nombre: "Francisco Javier Mariátegui", valle: "Lima", fundacion: "1967" },
  { numero: 77, nombre: "Delta", valle: "Lima", fundacion: "1966" },
  { numero: 78, nombre: "Delfos", valle: "Lima", fundacion: "1966" },
  { numero: 79, nombre: "La Cantera", valle: "Lima", fundacion: "1969" },
  { numero: 80, nombre: "Luz del Cumbe", valle: "Cajamarca", fundacion: "1967" },
  { numero: 81, nombre: "El Solitario de Sayán", valle: "Trujillo", fundacion: "1967" },
  { numero: 82, nombre: "Toribio Rodríguez de Mendoza", valle: "Tarapoto", fundacion: "1968" },
  { numero: 83, nombre: "Progreso de Pacasmayo", valle: "Pacasmayo", fundacion: "1967" },
  { numero: 84, nombre: "Perfecto Ashlar", valle: "Lima", fundacion: "1968" },
  { numero: 85, nombre: "Miguel de San Román", valle: "Juliaca", fundacion: "1968" },
  { numero: 86, nombre: "Benjamín Pérez Treviño", valle: "Lima", fundacion: "1968" },
  { numero: 87, nombre: "Luz de Amazonas", valle: "Chachapoyas", fundacion: "1968" },
  { numero: 88, nombre: "Luz en el Sendero", valle: "Arequipa", fundacion: "1968" },
  { numero: 89, nombre: "Harold Golfarb", valle: "Lima", fundacion: "1969" },
  { numero: 90, nombre: "Pachacútec", valle: "Ica", fundacion: "1969" },
  { numero: 91, nombre: "Alberto Heller", valle: "Arequipa", fundacion: "1969" },
  { numero: 92, nombre: "Dos de Mayo", valle: "Callao", fundacion: "1969" },
  { numero: 93, nombre: "Gran Chimú", valle: "Trujillo", fundacion: "1969" },
  { numero: 94, nombre: "Juan Manuel Iturregui", valle: "Trujillo", fundacion: "1969" },
  { numero: 95, nombre: "Felipe Enrique Espinar", valle: "Lima", fundacion: "1970" },
  { numero: 96, nombre: "Libertadores José Nemi Traad", valle: "Pisco", fundacion: "1970" },
  { numero: 97, nombre: "Regeneración Fraternal 9", valle: "Lima", fundacion: "1970" },
  { numero: 98, nombre: "Piedra Blanca de la Perfección", valle: "Tacna", fundacion: "1971" },
  { numero: 99, nombre: "El Silencio", valle: "Trujillo", fundacion: "1971" },
  { numero: 100, nombre: "Constitución", valle: "Callao", fundacion: "1970" },
  { numero: 101, nombre: "Firme y Feliz por la Unión", valle: "Lima", fundacion: "1972" },
  { numero: 102, nombre: "Bernardo O'Higgins", valle: "Lima", fundacion: "1971" },
  { numero: 103, nombre: "Simón Bolívar", valle: "Lima", fundacion: "1971" },
  { numero: 104, nombre: "Unión Justa 7", valle: "Ferreñafe", fundacion: "1971" },
  { numero: 105, nombre: "Rey Salomón", valle: "Lima", fundacion: "1971" },
  { numero: 106, nombre: "Jesús García Maldonado", valle: "Lima", fundacion: "1967" },
  { numero: 107, nombre: "Perfección", valle: "Lima", fundacion: "1971" },
  { numero: 108, nombre: "Perla del Huallaga", valle: "Yurimaguas", fundacion: "1972" },
  { numero: 109, nombre: "Francisco de Miranda", valle: "Lima", fundacion: "1972" },
  { numero: 110, nombre: "Estrella Polar 10", valle: "Lima", fundacion: "1972" },
  { numero: 111, nombre: "Seis de Agosto", valle: "Lima", fundacion: "1972" },
  { numero: 112, nombre: "Ramón Castilla", valle: "Lima", fundacion: "1973" },
  { numero: 113, nombre: "Luz en el Valle", valle: "Chocope", fundacion: "1973" },
  { numero: 114, nombre: "Giuseppe Garibaldi", valle: "Lima", fundacion: "1974" },
  { numero: 115, nombre: "Luz de Chota", valle: "Chota", fundacion: "1971" },
  { numero: 116, nombre: "Luz del Mayo", valle: "Moyobamba", fundacion: "1974" },
  { numero: 117, nombre: "Chavín de Huantar", valle: "Huaraz", fundacion: "1975" },
  { numero: 118, nombre: "Mantaro", valle: "Lima", fundacion: "1975" },
  { numero: 119, nombre: "Maquinguayo", valle: "Huancayo", fundacion: "1975" },
  { numero: 120, nombre: "Tradición y Verdad", valle: "Chiclayo", fundacion: "1975" },
  { numero: 121, nombre: "José Gálvez Barrenechea", valle: "Lima", fundacion: "1976" },
  { numero: 122, nombre: "Filosofía Peruana 10", valle: "Ica", fundacion: "1826" },
  { numero: 123, nombre: "Huaytapallana", valle: "Huancayo", fundacion: "1976" },
  { numero: 124, nombre: "Fortaleza y Unión", valle: "Barranca", fundacion: "1977" },
  { numero: 125, nombre: "Antonio José de Sucre", valle: "Lima", fundacion: "1977" },
  { numero: 126, nombre: "Enrique Solís Polo", valle: "Lima", fundacion: "1977" },
  { numero: 127, nombre: "Libertad Universal", valle: "Lima", fundacion: "1977" },
  { numero: 128, nombre: "Andrómeda", valle: "Lima", fundacion: "1977" },
  { numero: 129, nombre: "Unidad", valle: "Lima", fundacion: "1978" },
  { numero: 130, nombre: "Kronos", valle: "Lima", fundacion: "1978" },
  { numero: 131, nombre: "Libertadores de América", valle: "Lima", fundacion: "1978" },
  { numero: 132, nombre: "Antonio Raimondi", valle: "Lima", fundacion: "1980" },
  { numero: 133, nombre: "Jorge Basadre Grohmann", valle: "Lima", fundacion: "1980" },
  { numero: 134, nombre: "Waldo Olivos Torrejón", valle: "Lima", fundacion: "1980" },
  { numero: 135, nombre: "Urusayhua", valle: "Quillabamba", fundacion: "1981" },
  { numero: 136, nombre: "Fraternidad Lambayecana", valle: "Chiclayo", fundacion: "1981" },
  { numero: 137, nombre: "Fénix", valle: "Lima", fundacion: "1981" },
  { numero: 138, nombre: "Luz en el Remanso", valle: "Chaclacayo", fundacion: "1981" },
  { numero: 139, nombre: "Luz de Renacimiento", valle: "Lima", fundacion: "1981" },
  { numero: 140, nombre: "José Ángel Escalante Fuentes", valle: "Lima", fundacion: "1981" },
  { numero: 141, nombre: "Wiracocha", valle: "Sicuani", fundacion: "1982" },
  { numero: 142, nombre: "Fraternidad y Justicia", valle: "Lima", fundacion: "1978" },
  { numero: 143, nombre: "Víctor Raúl Haya de la Torre", valle: "Lima", fundacion: "1983" },
  { numero: 144, nombre: "De Lima", valle: "Lima", fundacion: "1983" },
  { numero: 145, nombre: "Ignacio Álvarez Thomas", valle: "Arequipa", fundacion: "1984" },
  { numero: 146, nombre: "Unión y Armonía", valle: "Iquitos", fundacion: "1985" },
  { numero: 147, nombre: "José Abelardo Quiñones Gonzáles", valle: "Lima", fundacion: "1985" },
  { numero: 148, nombre: "Sol de los Andes", valle: "Moquegua", fundacion: "1987" },
  { numero: 149, nombre: "Integración", valle: "Lima", fundacion: "1988" },
  { numero: 150, nombre: "Magíster", valle: "Lima", fundacion: "1988" },
  { numero: 151, nombre: "Menfis", valle: "Lima", fundacion: "1988" },
  { numero: 152, nombre: "Unión Escocesa", valle: "Lima", fundacion: "1977" },
  { numero: 153, nombre: "Perseverancia", valle: "Lima", fundacion: "1988" },
  { numero: 154, nombre: "Andrés Cordano Cavagnaro", valle: "Lima", fundacion: "1969" },
  { numero: 155, nombre: "Arca de la Nueva Alianza", valle: "Lima", fundacion: "1991" },
  { numero: 156, nombre: "Gran Almirante Miguel Grau", valle: "Lima", fundacion: "1990" },
  { numero: 157, nombre: "Justicia, Bondad y Moralidad", valle: "Trujillo", fundacion: "1990" },
  { numero: 158, nombre: "La Pirámide", valle: "Lima", fundacion: "1991" },
  { numero: 159, nombre: "Arte Real", valle: "Lima", fundacion: "1991" },
  { numero: 160, nombre: "Unión Indisoluble 6", valle: "Piura", fundacion: "1992" },
  { numero: 161, nombre: "Hiram Abi", valle: "Monsefú", fundacion: "1994" },
  { numero: 162, nombre: "Monitor Huáscar", valle: "Lima", fundacion: "1995" },
  { numero: 163, nombre: "Centro Cósmico", valle: "Puno", fundacion: "1996" },
  { numero: 164, nombre: "Cruz de Piedra", valle: "Cajamarca", fundacion: "1997" },
  { numero: 165, nombre: "Caballeros del Fuego", valle: "Lima", fundacion: "1998" },
  { numero: 166, nombre: "Julio Francisco de Iriarte", valle: "Lima", fundacion: "1998" },
  { numero: 167, nombre: "Ucayali 21", valle: "Contamana", fundacion: "1998" },
  { numero: 168, nombre: "Luz Naciente", valle: "Pimentel", fundacion: "1999" },
  { numero: 169, nombre: "Armonía y Fraternidad", valle: "Lima", fundacion: "2003" },
  { numero: 170, nombre: "Centauro de las Vilcas", valle: "Pocollay", fundacion: "2001" },
  { numero: 171, nombre: "Unión, Perseverancia y Fortaleza", valle: "Lima", fundacion: "2003" },
  { numero: 172, nombre: "Paz, Armonía y Libertad", valle: "Lima", fundacion: "2003" },
  { numero: 173, nombre: "Géminis", valle: "Lima", fundacion: "2003" },
  { numero: 174, nombre: "Alfa y Omega", valle: "Lima", fundacion: "2004" },
  { numero: 175, nombre: "Luz del Misti", valle: "Arequipa", fundacion: "2005" },
  { numero: 176, nombre: "Cibeles", valle: "Lima", fundacion: "2009" },
  { numero: 177, nombre: "Inca Garcilaso de la Vega", valle: "Lima", fundacion: "2009" },
  { numero: 178, nombre: "George Washington", valle: "Lima", fundacion: "2009" },
  { numero: 179, nombre: "Mariscal Andrés Avelino Cáceres Dorregaray", valle: "Lima", fundacion: "2009" },
  { numero: 180, nombre: "Fortaleza Real Felipe", valle: "Lima", fundacion: "2006" },
  { numero: 181, nombre: "Caballeros de los Andes", valle: "Huancayo", fundacion: "2010" },
  { numero: 182, nombre: "Wolfgang Amadeus Mozart", valle: "Lima", fundacion: "2011" },
  { numero: 183, nombre: "José Eleodoro Landívar Vargas", valle: "Chiclayo", fundacion: "2011" },
  { numero: 184, nombre: "Artesanos del Silencio", valle: "Tacna", fundacion: "2012" },
  { numero: 185, nombre: "Caballeros del Templo", valle: "Arequipa", fundacion: "2012" },
  { numero: 186, nombre: "Mariano Necochea", valle: "Lima", fundacion: "2013" },
  { numero: 187, nombre: "Filosofía y Fraternidad", valle: "Lima", fundacion: "2013" },
  { numero: 188, nombre: "Federico Alzamora Pequeño", valle: "Iquitos", fundacion: "2013" },
  { numero: 189, nombre: "Fraternidad Americana", valle: "Lima", fundacion: "2013" },
  { numero: 190, nombre: "Fraternidad", valle: "Lima", fundacion: "2013" },
  { numero: 191, nombre: "Egregor", valle: "Huancayo", fundacion: "2013" },
  { numero: 192, nombre: "Enrique Maravoto Goytizolo", valle: "Lima", fundacion: "2013" },
  { numero: 193, nombre: "La Escuadra y El Compás", valle: "Huarochiri", fundacion: "2013" },
  { numero: 194, nombre: "José Santos Grocio Prado Linares", valle: "Chincha", fundacion: "2013" },
  { numero: 195, nombre: "Jerusalem (antes Mahatma Gandhi)", valle: "Lima", fundacion: "2013" },
  { numero: 196, nombre: "Estrella del Sur", valle: "Lima", fundacion: "2014" },
  { numero: 197, nombre: "Chan Chan", valle: "Trujillo", fundacion: "2013" },
  { numero: 198, nombre: "Genesis", valle: "Lima", fundacion: "2014" },
  { numero: 199, nombre: "Sagitario", valle: "Lima", fundacion: "2014" },
  { numero: 200, nombre: "Honor y Lealtad", valle: "Lima", fundacion: "2014" },
  { numero: 201, nombre: "Sol Naciente", valle: "Lima", fundacion: "2014" },
  { numero: 202, nombre: "Jean Baptiste Willermoz", valle: "Lima", fundacion: "2014" },
  { numero: 203, nombre: "Caballeros del Norte", valle: "Trujillo", fundacion: "2014" },
  { numero: 204, nombre: "Catequil", valle: "Cajamarca", fundacion: "2014" },
  { numero: 205, nombre: "Luz del Creador", valle: "Lima", fundacion: "2015" },
  { numero: 206, nombre: "Caballeros de la Luz", valle: "Piura", fundacion: "2015" },
  { numero: 207, nombre: "Cruz del Sur", valle: "Lima", fundacion: "2015" },
  { numero: 208, nombre: "Machupicchu", valle: "Cusco", fundacion: "2016" },
  { numero: 209, nombre: "Cordillera Azul", valle: "Tarapoto", fundacion: "2016" },
  { numero: 210, nombre: "Laguna Azul", valle: "Tarapoto", fundacion: "2016" },
  { numero: 211, nombre: "Miguel Monteverde Win", valle: "Callao", fundacion: "2016" },
  { numero: 212, nombre: "Cesar Vallejo", valle: "Lima", fundacion: "2016" },
  { numero: 213, nombre: "Sur Oriente Amazónico", valle: "Puerto Maldonado", fundacion: "2016" },
  { numero: 214, nombre: "Unity 1109", valle: "Lima", fundacion: "2017" },
  { numero: 215, nombre: "Luz de Paracas", valle: "Pisco", fundacion: "2017" },
  { numero: 216, nombre: "Fraternidad Bolivariana", valle: "Lima", fundacion: "2017" },
  { numero: 217, nombre: "Unión Fraternal", valle: "Lima", fundacion: "2018" },
  { numero: 218, nombre: "De Ica", valle: "Ica", fundacion: "2018" },
  { numero: 219, nombre: "Ayacucho 7", valle: "Ayacucho", fundacion: "2018" },
  { numero: 220, nombre: "Kybalión", valle: "San Martín", fundacion: "2019" },
  { numero: 221, nombre: "Kuelap", valle: "Chachapoyas", fundacion: "2019" },
  { numero: 222, nombre: "Mariano Melgar", valle: "Arequipa", fundacion: "2019" },
  { numero: 223, nombre: "Wari", valle: "Callao", fundacion: "2019" },
  { numero: 224, nombre: "Kilwinning", valle: "Cusco", fundacion: "2020" },
  { numero: 225, nombre: "Mariano Santos Mateo", valle: "Lima", fundacion: "2020" },
  { numero: 226, nombre: "Luis Alberto Félix Sánchez Sánchez", valle: "Lima", fundacion: "2022" },
  { numero: 227, nombre: "Atanor", valle: "Lima", fundacion: "2022" },
  { numero: 228, nombre: "Gnosis", valle: "Trujillo", fundacion: "2022" },
  { numero: 229, nombre: "Constancia Peruana", valle: "Ica", fundacion: "2023" },
  { numero: 230, nombre: "Roof Of The World 1094", valle: "Lima", fundacion: "2023" },
  { numero: 231, nombre: "Benito Juárez Garcia", valle: "Lima", fundacion: "2023" },
  { numero: 232, nombre: "Fraternidad Quantica", valle: "Lima", fundacion: "2024" },
  { numero: 233, nombre: "Union y Orden", valle: "Tarapoto", fundacion: "2024" },
  { numero: 234, nombre: "Mariano Damaso Beraun Fuentes", valle: "Conchamarca", fundacion: "2024" },
  { numero: 235, nombre: "Manuel Cipriano Dulanto Valenzuela", valle: "Lima", fundacion: "2025" },
  { numero: 236, nombre: "Tabernaculo", valle: "Ramón Castilla", fundacion: "2025" },
  { numero: 237, nombre: "Guardianes de la Patria", valle: "Caballococha", fundacion: "2025" },
  { numero: 1, nombre: "Lodge Peace & Concord", valle: "Lima", fundacion: "1865" }
];

const LogiasGLP = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedValle, setSelectedValle] = useState('Todos');

  // Efecto para hacer scroll al inicio al cargar la vista
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Extraer Valles únicos para el filtro
  const vallesUnicos = ['Todos', ...new Set(logiasData.map(logia => logia.valle))].sort();

  // Lógica de filtrado en tiempo real
  const logiasFiltradas = logiasData.filter(logia => {
    const coincideBusqueda = 
      logia.nombre.toLowerCase().includes(searchTerm.toLowerCase()) ||
      logia.numero.toString().includes(searchTerm);
    const coincideValle = selectedValle === 'Todos' || logia.valle === selectedValle;
    
    return coincideBusqueda && coincideValle;
  });

  return (
    <div className="min-h-screen bg-[#050505] text-white selection:bg-[#C5A059] selection:text-[#050505] font-sans pt-24 flex flex-col">
      
      {/* Hero Section */}
      <section className="relative w-full pt-32 pb-16 md:pt-40 md:pb-24 flex flex-col items-center justify-center overflow-hidden border-b border-white/5">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-20"
          style={{ backgroundImage: "url('https://images.unsplash.com/photo-1541888086925-921eb234c900?q=80&w=2000&auto=format&fit=crop')" }} 
        ></div>
        <div className="absolute inset-0 bg-gradient-to-b from-[#050505]/90 via-[#050505]/60 to-[#050505]"></div>

        <div className="relative z-10 text-center px-4 w-full max-w-4xl mx-auto">
          <p className="text-[#C5A059] tracking-[0.4em] uppercase text-xs md:text-sm font-light mb-4 animate-fade-in">
            Estructura Jurisdiccional
          </p>
          <h1 className="font-serif text-4xl md:text-6xl font-normal text-white tracking-tight animate-fade-in [animation-delay:0.3s] drop-shadow-lg mb-6">
            Logias del Perú
          </h1>
          <p className="text-gray-400 font-light text-sm md:text-base max-w-2xl mx-auto animate-fade-in [animation-delay:0.6s]">
            Actualmente nuestra jurisdicción está conformada por 238 Respetables Logias Simbólicas trabajando en casi la totalidad de los departamentos de la República.
          </p>
        </div>
      </section>

      {/* Contenido Principal */}
      <section className="relative z-20 max-w-[90rem] mx-auto px-6 lg:px-12 py-16 md:py-24 flex-grow w-full">
        
        {/* Panel de Búsqueda y Filtros */}
        <div className="bg-gradient-to-br from-[#0a0a0a] to-[#111111] border border-white/5 p-6 md:p-8 mb-12 shadow-2xl flex flex-col md:flex-row gap-6 items-center justify-between">
          
          <div className="w-full md:w-1/2 relative">
            <svg className="absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
            <input 
              type="text" 
              placeholder="Buscar por Nombre o Número de Logia..." 
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full bg-[#050505] border border-white/10 text-white pl-12 pr-4 py-4 focus:outline-none focus:border-[#C5A059] transition-colors placeholder-gray-600 font-light"
            />
          </div>

          <div className="w-full md:w-1/3 flex items-center gap-4">
            <span className="text-[#C5A059] text-xs tracking-widest uppercase hidden lg:block">Filtrar:</span>
            <select 
              value={selectedValle}
              onChange={(e) => setSelectedValle(e.target.value)}
              className="w-full bg-[#050505] border border-white/10 text-gray-300 px-4 py-4 focus:outline-none focus:border-[#C5A059] transition-colors appearance-none cursor-pointer"
            >
              {vallesUnicos.map((valle, idx) => (
                <option key={idx} value={valle}>
                  {valle === 'Todos' ? 'Todos los Valles' : `Valle de ${valle}`}
                </option>
              ))}
            </select>
          </div>

        </div>

        {/* Grilla de Resultados */}
        <div className="mb-6 flex justify-between items-center border-b border-white/10 pb-4">
          <h2 className="font-serif text-2xl text-white">Directorio de Talleres</h2>
          <span className="text-gray-500 text-xs tracking-widest uppercase">
            {logiasFiltradas.length} Logias encontradas
          </span>
        </div>

        {logiasFiltradas.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6">
            {logiasFiltradas.map((logia, idx) => (
              <div key={idx} className="group bg-[#0a0a0a] border border-white/5 p-6 hover:border-[#C5A059]/40 hover:-translate-y-1 transition-all duration-300 flex flex-col justify-between h-full">
                <div>
                  <div className="flex justify-between items-start mb-4">
                    <span className="text-[#C5A059] font-serif text-3xl font-light">N° {logia.numero}</span>
                  </div>
                  <h3 className="font-serif text-xl text-white mb-4 group-hover:text-[#C5A059] transition-colors">
                    {logia.nombre}
                  </h3>
                </div>
                
                <div className="pt-4 border-t border-white/5">
                  <div className="flex justify-between items-center">
                    <div>
                      <span className="block text-gray-600 text-[10px] tracking-widest uppercase mb-1">Valle de</span>
                      <span className="text-gray-300 text-sm font-medium tracking-wide">{logia.valle}</span>
                    </div>
                    <div className="text-right">
                      <span className="block text-gray-600 text-[10px] tracking-widest uppercase mb-1">Fundación</span>
                      <span className="text-gray-400 text-sm font-mono">{logia.fundacion || "---"}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-20 bg-[#0a0a0a] border border-white/5">
            <svg className="w-12 h-12 text-gray-600 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
            <p className="text-gray-400 text-lg font-light">No se encontraron logias que coincidan con tu búsqueda.</p>
            <button 
              onClick={() => { setSearchTerm(''); setSelectedValle('Todos'); }}
              className="mt-6 text-[#C5A059] text-xs tracking-widest uppercase hover:text-white border-b border-[#C5A059] pb-1 transition-colors"
            >
              Limpiar Filtros
            </button>
          </div>
        )}

      </section>
    </div>
  );
};

export default LogiasGLP;